"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TooltipHOC = function TooltipHOComponent(WrappedComponent) {
  var TooltipHOC = /*#__PURE__*/function (_Component) {
    _inherits(TooltipHOC, _Component);

    var _super = _createSuper(TooltipHOC);

    function TooltipHOC(props) {
      var _this;

      _classCallCheck(this, TooltipHOC);

      _this = _super.call(this, props);
      _this.msgRef = /*#__PURE__*/_react["default"].createRef();
      _this.tooltipPositionRef = /*#__PURE__*/_react["default"].createRef();
      _this.config = {
        msgPadding: 20,
        iconDimensions: 0,
        alignMsg: 'left'
      };
      _this.setConfig = _this.setConfig.bind(_assertThisInitialized(_this));
      _this.toggleTooltip = _this.toggleTooltip.bind(_assertThisInitialized(_this));
      _this.renderMsgBlock = _this.renderMsgBlock.bind(_assertThisInitialized(_this));
      _this.handleOutsideClick = _this.handleOutsideClick.bind(_assertThisInitialized(_this));
      _this.handleOutsideKeyPress = _this.handleOutsideKeyPress.bind(_assertThisInitialized(_this));
      _this.state = {
        showTooltip: false,
        position: {},
        shiftLeft: {
          left: 0
        }
      };
      return _this;
    }

    _createClass(TooltipHOC, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var showTooltip = this.state.showTooltip;

        if (prevState.showTooltip !== showTooltip) {
          this.positionMsgInWindow();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.handleEventListeners(false);
      }
    }, {
      key: "setConfig",
      value: function setConfig(config) {
        this.config = _objectSpread(_objectSpread({}, this.config), config);
      }
    }, {
      key: "getTooltipPosition",
      value: function getTooltipPosition() {
        var shiftCoefficient = 1.5;
        var _this$config = this.config,
            alignMsg = _this$config.alignMsg,
            iconDimensions = _this$config.iconDimensions;
        var rect = this.tooltipPositionRef.current.getBoundingClientRect();
        var offsetTop = this.tooltipPositionRef.current.offsetTop;
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        return {
          rightEdgePosition: rect.left + scrollLeft,
          left: rect[alignMsg] + scrollLeft - iconDimensions * shiftCoefficient,
          top: offsetTop + rect.height
        };
      }
    }, {
      key: "toggleTooltip",
      value: function toggleTooltip(show) {
        var showTooltip = this.state.showTooltip;

        if (show !== showTooltip) {
          if (show) {
            var position = this.getTooltipPosition();

            if (position.rightEdgePosition <= document.documentElement.clientWidth) {
              this.handleEventListeners(true);
              this.setState({
                showTooltip: true,
                position: position
              });
            }
          } else {
            this.handleEventListeners(false);
            this.setState({
              showTooltip: false
            });
          }
        }
      }
    }, {
      key: "handleEventListeners",
      value: function handleEventListeners(tooltipOpen) {
        if (tooltipOpen) {
          window.addEventListener('keyup', this.handleOutsideKeyPress);
          window.addEventListener('click', this.handleOutsideClick);
          window.addEventListener('touchstart', this.handleOutsideClick);
        } else {
          window.removeEventListener('keyup', this.handleOutsideKeyPress);
          window.removeEventListener('click', this.handleOutsideClick);
          window.removeEventListener('touchstart', this.handleOutsideClick);
        }
      }
    }, {
      key: "handleOutsideClick",
      value: function handleOutsideClick() {
        this.toggleTooltip(false);
      }
    }, {
      key: "handleOutsideKeyPress",
      value: function handleOutsideKeyPress(_ref) {
        var target = _ref.target;
        var showTooltip = false;

        if (this.tooltipPositionRef.current) {
          showTooltip = this.tooltipPositionRef.current.contains(target);
        }

        this.toggleTooltip(showTooltip);
      }
    }, {
      key: "positionMsgInWindow",
      value: function positionMsgInWindow() {
        var xPosition = this.msgRef.current.getBoundingClientRect().right;
        var windowWidth = document.documentElement.clientWidth;
        var rightEdgePosition = this.config.msgPadding + xPosition;
        var shift = rightEdgePosition > windowWidth ? windowWidth - rightEdgePosition : 0;
        this.setState({
          shiftLeft: {
            left: "".concat(shift, "px")
          }
        });
      }
    }, {
      key: "renderMsgBlock",
      value: function renderMsgBlock(msgBlock) {
        var styleFlag = this.props.styleFlag;
        var _this$state = this.state,
            showTooltip = _this$state.showTooltip,
            shiftLeft = _this$state.shiftLeft,
            position = _this$state.position;
        var showTooltipClass = (0, _classnames["default"])('marketplace-tooltip__msg', {
          'marketplace-tooltip__msg--visible': showTooltip
        });
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "tooltip--".concat(styleFlag)
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: showTooltipClass,
          style: position
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "marketplace-tooltip__marker"
        }), /*#__PURE__*/_react["default"].createElement("span", {
          ref: this.msgRef,
          style: shiftLeft,
          className: "marketplace-tooltip__msg-container"
        }, msgBlock)));
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "marketplace-tooltip",
          role: "button",
          tabIndex: 0,
          ref: this.tooltipPositionRef,
          onKeyPress: function onKeyPress() {},
          onFocus: function onFocus() {
            return _this2.toggleTooltip(true);
          },
          onMouseOver: function onMouseOver() {
            return _this2.toggleTooltip(true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.toggleTooltip(false);
          },
          onTouchEnd: function onTouchEnd() {
            return _this2.toggleTooltip(true);
          },
          onClick: function onClick(event) {
            return event.stopPropagation();
          }
        }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, this.props, {
          state: this.state,
          setConfig: this.setConfig,
          renderMsgBlock: this.renderMsgBlock,
          toggleTooltip: this.toggleTooltip
        })));
      }
    }]);

    return TooltipHOC;
  }(_react.Component);

  TooltipHOC.propTypes = {
    styleFlag: _propTypes["default"].string
  };
  TooltipHOC.defaultProps = {
    styleFlag: 'tax'
  };
  return TooltipHOC;
};

var _default = TooltipHOC;
exports["default"] = _default;